import { useEffect, useState } from "react";
import { Box, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import ShuffleRounded from "@mui/icons-material/ShuffleRounded";
import { grey } from "@mui/material/colors";

const pickPair = (items = []) => {
	if (!items.length) return [0, 0];
	const first = Math.floor(Math.random() * items.length);
	let second = Math.floor(Math.random() * items.length);
	if (items.length > 1) {
		while (second === first) second = Math.floor(Math.random() * items.length);
	}
	return [first, second];
};

const GigaAdPreview = ({ ad, displayUrl = "www.example.com", maxWidth = "100%" }) => {
	const headlines = ad?.headlines || [];
	const descriptions = ad?.descriptions || [];
	const [headlinePair, setHeadlinePair] = useState([0, Math.min(1, Math.max(0, headlines.length - 1))]);
	const [descriptionIndex, setDescriptionIndex] = useState(0);

	const shuffleHeadlines = () => setHeadlinePair(pickPair(headlines));
	const shuffleDescription = () => {
		if (!descriptions.length) return;
		setDescriptionIndex(Math.floor(Math.random() * descriptions.length));
	};

	useEffect(() => {
		setHeadlinePair(pickPair(headlines));
		setDescriptionIndex(descriptions.length ? Math.floor(Math.random() * descriptions.length) : 0);
	}, [ad]);

	if (!headlines.length) return null;

	const h1 = headlines[headlinePair[0]] || headlines[0];
	const h2 = headlines.length > 1 ? headlines[headlinePair[1]] : "";

	return (
		<Box
			sx={{
				p: 2,
				bgcolor: "#fff",
				border: `1px solid ${grey[200]}`,
				borderRadius: 2,
				width: "100%",
				maxWidth,
				boxSizing: "border-box",
				fontFamily: "Arial, sans-serif",
				overflow: "hidden",
			}}>
			<Typography fontSize={12} color={grey[700]}>
				<Box component="span" fontWeight={700} mr={1}>
					Ad
				</Box>
				{displayUrl}
			</Typography>
			<Stack direction="row" alignItems="flex-start" spacing={0.75} sx={{ mt: 0.5 }}>
				<Typography
					sx={{
						color: "#1a0dab",
						fontSize: 18,
						lineHeight: 1.3,
						fontWeight: 400,
						wordBreak: "break-word",
						flex: 1,
					}}>
					{h1}
					{h2 ? ` | ${h2}` : ""}
				</Typography>
				<Tooltip title="Shuffle headlines">
					<IconButton size="small" onClick={shuffleHeadlines} sx={{ mt: 0.25, color: grey[500] }}>
						<ShuffleRounded sx={{ fontSize: 16 }} />
					</IconButton>
				</Tooltip>
			</Stack>
			<Stack direction="row" alignItems="flex-start" spacing={0.75} sx={{ mt: 0.5 }}>
				<Typography fontSize={14} color={grey[700]} sx={{ lineHeight: 1.55, wordBreak: "break-word", flex: 1 }}>
					{descriptions[descriptionIndex] || descriptions.join(" ")}
				</Typography>
				{descriptions.length > 1 && (
					<Tooltip title="Shuffle description">
						<IconButton size="small" onClick={shuffleDescription} sx={{ color: grey[500] }}>
							<ShuffleRounded sx={{ fontSize: 16 }} />
						</IconButton>
					</Tooltip>
				)}
			</Stack>
		</Box>
	);
};

export default GigaAdPreview;
